require('./parameters.less');

class ParametersController {
    parameters;

    toolbarHeaderDefinition = {
        isTable: true,
        toolbarHeading: "Parametre"
    };

    constructor(private toastService, private Parameters, private $filter){
    }

    $onInit() {
        this.Parameters.getParameters().$promise.then(
            (result) => {
                this.parameters = result.map(x => {
                if(x.dataType === 'INTEGER'){
                    x.value = parseInt(x.value);
                }else if(x.dataType === 'DATE'){
                    var date = new Date();
                    date.setHours(x.value.substr(0, 2));
                    date.setMinutes(x.value.substr(3, 2));
                    x.value = date;
                }
                return x;
                });
            }, (error) => {
                this.toastService.parseError(error);
            })
    }

    inputValueChanged (value) {
        var valToSave;
        if(value.dataType === 'DATE'){
            valToSave = this.$filter('date')(value.value, 'HH:mm');
        }else if(value.dataType === 'INTEGER'){
            valToSave = value.value + "";
        }else {
            valToSave = value.value;
        }
        this.Parameters.updateParameter({code: value.code}, {value: valToSave}).$promise.then(
            () => {},
            (error) => {
                this.toastService.parseError(error);
            }
        )
    }
}

class ParametersOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcParametersController";
    public template: any = require('./parameters.html');
}

rkcApp.controller("rkcParametersController", ['toastService', 'Parameters', '$filter', function( toastService, Parameters, $filter){
    return new ParametersController(toastService, Parameters, $filter);
}])
    .component("rkcParameters", new ParametersOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/parameters/parameters.ts
 **/